const formatPhone = (v) => {
    var r = v.replace(/\D/g, "");
    r = r.replace(/^0/, "");
    r = r.replace(/^(\d{2})(\d)/g, "($1) $2");
    r = r.replace(/(\d)(\d{4})$/, "$1-$2");
    return r;
  }
  
  export default formatPhone;
  